import { colors } from '@styles/vars/colors.style'
import {
  getCustomTextStyle,
  textStylesConfig,
} from '@styles/vars/textStyles.style'
import styled from 'styled-components'

export const IntroMain = styled.section`
  background-color: ${colors.charcoal};
  color: ${colors.white};
`

export const IntroTitle = styled.h1`
  max-width: 8em;
  strong {
    margin-right: 10px;
  }
  ${getCustomTextStyle(
    textStylesConfig.heading1Serif,
    textStylesConfig.superSerif
  )}
  br {
    display: none;
  }
`
